/* eslint-disable @typescript-eslint/no-explicit-any */
import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Modal from "common/components/Modal/Modal"
import { ModalLoading } from "common/components/ModalLoading/ModalLoading"
import notification from "common/utils/notification"
import { CSVToArray, excelToJsonCols } from "features/Importar/utils"
import { withFormik } from "formik"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { useState } from "react"
import Dropzone from "react-dropzone"
import { Trans, useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import imgIntegraciones from "../../../../../../assets/img-scan-integraciones.svg"
import subirDocumentoNube from "../../../../../../assets/subirDocumentoNube.svg"
import {
  MODES_INTEGRACIONES,
  OPTIONS_DROP,
  SAGE_INFO,
  TYPES_INTEGRACIONES,
  submitIntegration,
  validationSchemaIntegraciones,
} from "./contants"

const IntegrationUpdate = ({
  values,
  setFieldValue,
  errors,
  handleSubmit,
}: {
  values: $TSMigrationFixMe
  setFieldValue: (
    field: string,
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => void
  errors: $TSMigrationFixMe
  handleSubmit: $TSMigrationFixMe
}) => {
  const { t } = useTranslation()
  const [loadingTab, setLoadingTab] = useState(false)

  const handleValidExcelColumnsHeaders = (
    headers: string[],
    screen: string
  ) => {
    const validHeaders = headers.filter(Boolean)

    if (validHeaders.length < 2) {
      return false
    }

    const options = OPTIONS_DROP(t, screen)
    const mandatoryHeaders = options.flatMap((option) => option.aliases)
    const presentMandatoryHeaders = validHeaders.filter((header) =>
      mandatoryHeaders.some(
        (mandatoryHeader) =>
          header.trim().toLowerCase() === mandatoryHeader.trim().toLowerCase()
      )
    )

    if (presentMandatoryHeaders.length < 2) {
      return false
    }
    return true
  }

  const handleUploadExcel = async (
    acceptedFiles: Array<Blob & { name?: string }>
  ) => {
    if (!acceptedFiles[0] || acceptedFiles[0]?.size > 5120000) {
      return notification.warning({
        body: `${t("tickets.dropzone.maxWeight")}${
          values.screen === MODES_INTEGRACIONES.ASIENTOS_CONTABLES
            ? t("tickets.dropzone.recommendation")
            : ""
        }`,
        duration: 10000,
      })
    }
    setLoadingTab(true)
    const file = acceptedFiles[0]

    setFieldValue(
      `${values.screen}.nombreArchivo`,
      acceptedFiles[0]?.name ?? null
    )
    const archive =
      file.type === "text/csv"
        ? await CSVToArray(file)
        : await excelToJsonCols(file)

    if (!handleValidExcelColumnsHeaders(archive.headers, values.screen)) {
      notification.warning({
        body: `${t("notification.integrationInvalidExcelHeaders")}`,
        duration: 6000,
      })
      setLoadingTab(false)
      return
    }

    setFieldValue(`${values.screen}.archive`, archive)

    const updatedOptions: { [key: string]: $TSMigrationFixMe } = {}

    Object.keys(values?.[`${values.screen}`]?.options).forEach(
      (key: $TSMigrationFixMe) => {
        const index = archive.headers.findIndex((header: string) => {
          return OPTIONS_DROP(t, values.screen).some((option) => {
            return (
              option.aliases.some(
                (alias: string) =>
                  header.trim().toLowerCase() === alias.trim().toLowerCase()
              ) && key === option.id
            )
          })
        })

        if (index === -1) {
          updatedOptions[key] = null
        } else if (
          values.screen === MODES_INTEGRACIONES.CONTACTOS &&
          (key === "codigoProveedor" || key === "codigoCliente")
        ) {
          updatedOptions[key] = null
        } else {
          updatedOptions[key] = `col${index + 1}`
        }
      }
    )

    setFieldValue(`${values.screen}.options`, updatedOptions)
    setLoadingTab(false)
  }

  const transformObject = (obj: $TSMigrationFixMe) => {
    return Object.entries(obj).map(([label, value]) => ({
      label,
      value,
    }))
  }

  const handleTypeCol = (value: string, keyProp: string) => {
    const hasErrors = Boolean(errors?.[`${values.screen}`]?.options)

    Object.keys(values?.[`${values.screen}`]?.options).forEach(
      (key: $TSMigrationFixMe) => {
        Boolean(values?.[`${values.screen}`]?.options[key]) &&
          values?.[`${values.screen}`]?.options[key] === keyProp &&
          setFieldValue(`${values.screen}.options.${key}`, null, hasErrors)
      }
    )

    setFieldValue(`${values.screen}.options.${value}`, keyProp, hasErrors)
  }

  const TableComponent = ({ data }: { data: $TSMigrationFixMe }) => {
    return (
      <div className='tw-w-full tw-overflow-auto'>
        <table className='tw-w-auto'>
          <thead>
            <tr className='tw-h-16 tw-w-auto'>
              {Object.keys(data[0]).map(
                (key: $TSMigrationFixMe, index: number) => {
                  return (
                    <th key={key}>
                      <div className='tw-w-48 tw-mx-1 tw-h-full tw-text-nowrap tw-flex tw-items-center'>
                        <Dropdown
                          value={
                            (values?.[`${values.screen}`]?.options &&
                              transformObject(
                                values?.[`${values.screen}`]?.options
                              ).find((element: $TSMigrationFixMe) => {
                                return element.value === key
                              })?.label) ??
                            null
                          }
                          options={OPTIONS_DROP(t, values.screen)}
                          optionValue='id'
                          optionLabel='value'
                          onChange={({ value }: { value: string }) => {
                            handleTypeCol(value, key)
                          }}
                          id={`inputTypeColum${index}`}
                          inputId={`inputTypeColum${index}`}
                          placeholder='Identifique columna'
                          className={`tw-w-48 tw-mx-1 ${
                            errors?.[`${values.screen}`]
                              ? "tw-border-danger"
                              : ""
                          }`}
                        />
                      </div>
                    </th>
                  )
                }
              )}
            </tr>
          </thead>
          <tbody>
            {data
              .filter((_value: $TSMigrationFixMe, index: number) => index < 7)
              .map((item: $TSMigrationFixMe, index: number) => {
                return (
                  <tr
                    key={`elementoContainer${index + 1}`}
                    className='tw-h-16 tw-w-auto !tw-border-b !tw-border-neutral-25'
                  >
                    {Object.values(item).map(
                      (value: $TSMigrationFixMe, index: number) => (
                        <td key={`elemento${index + 1}`}>
                          <div className='tw-flex tw-mx-1 tw-h-full tw-text-nowrap tw-px-3 tw-items-center tw-truncate tw-w-48 tw-text-ellipsis'>
                            {value}
                          </div>
                        </td>
                      )
                    )}
                  </tr>
                )
              })}
          </tbody>
        </table>
        <p className='tw-mt-3 tw-mb-0 tw-text-sm tw-w-full tw-text-start'>
          {t("empresasGestionadas.modal.masive.totalAcount")}{" "}
          {data.length ? data.length : "0"}
        </p>
      </div>
    )
  }

  return (
    <div className='tw-flex tw-flex-col tw-h-full'>
      <div className='tw-px-6 tw-bg-white tw-w-full tw-justify-between tw-flex tw-flex-row !tw-h-16 tw-items-center tw-shadow tw-mb-6 tw-font-medium'>
        {t("integracion.update.title")} - {values.type.toUpperCase()}
      </div>
      <div className='tw-w-full tw-px-6 tw-py-1 tw-flex-grow tw-overflow-auto'>
        <div className='tw-w-full tw-bg-white tw-flex tw-flex-col tw-p-6 tw-items-start tw-shadow tw-rounded-md'>
          <div className='tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center'>
            <div className='tw-flex tw-flex-col'>
              <div className='tw-w-full tw-flex tw-flex-row tw-font-medium'>
                <FontAwesomeIcon
                  icon={[
                    "fal",
                    values.screen === MODES_INTEGRACIONES.ASIENTOS_CONTABLES
                      ? "table"
                      : "file-invoice",
                  ]}
                  className='tw-h-5 tw-w-4 tw-mr-3'
                />
                <p className='tw-m-0'>
                  {values.screen === MODES_INTEGRACIONES.ASIENTOS_CONTABLES
                    ? t("integracion.update.asientoContable")
                    : values.screen === MODES_INTEGRACIONES.CONTACTOS
                    ? t("integracion.update.contact")
                    : t("integracion.update.libroIva")}
                </p>
              </div>

              <p className='tw-m-0 tw-mt-4 tw-w-full tw-text-wrap tw-text-start'>
                {t("integracion.update.text")}
              </p>
            </div>
            <Button
              type='button'
              onClick={() => setFieldValue(`${values.screen}.archive`, null)}
              className='!tw-bg-transparent !tw-text-danger !tw-border-transparent hover:!tw-text-danger hover:!tw-border-danger tw-rounded  tw-cursor-pointer tw-flex tw-flex-row tw-items-center tw-w-fit tw-h-fit tw-px-4 tw-py-2'
            >
              <FontAwesomeIcon
                icon={["fal", "trash-can"]}
                className='tw-w-5 tw-h-5 tw-mr-1'
              />
              <p className='tw-m-0'>{t("integracion.update.delete")}</p>
            </Button>
          </div>

          <div className='tw-flex-1 tw-max-w-full tw-w-full'>
            <Dropzone
              maxSize={5120000}
              accept={[
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel.sheet.macroEnabled.12",
                "application/vnd.ms-excel.template.macroEnabled.12",
                "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
                "text/csv",
              ]}
              onDrop={handleUploadExcel}
              noClick
              noKeyboard
            >
              {({ getRootProps, getInputProps, open }) => (
                <section className='tw-w-full tw-h-full'>
                  <div
                    {...getRootProps({ className: "dropzone" })}
                    className='tw-w-full tw-h-full tw-cursor-default'
                  >
                    <input
                      className='tw-hidden tw-cursor-default'
                      {...getInputProps()}
                    />
                    {values?.[`${values.screen}`]?.archive ? (
                      <div className='!tw-w-full !tw-max-w-full'>
                        <TableComponent
                          data={values?.[`${values.screen}`]?.archive?.items}
                        />
                        {errors && errors?.[`${values.screen}`]?.options && (
                          <div className='tw-w-full tw-flex tw-flex-row tw-flex-wrap'>
                            {Object.keys(
                              errors?.[`${values.screen}`]?.options
                            ).map((elemento: $TSMigrationFixMe) => (
                              <p
                                key={elemento}
                                className='tw-bg-danger-20 tw-text-white tw-rounded-md tw-text-xs tw-m-0 tw-px-2 tw-py-1 tw-my-1 tw-mx-1 tw-w-fit'
                              >
                                {
                                  errors?.[`${values.screen}`]?.options?.[
                                    elemento
                                  ]
                                }
                              </p>
                            ))}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        className={`tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-full tw-p-10 tw-cursor-default ${
                          errors?.[`${values.screen}`]?.archive
                            ? "tw-border-danger"
                            : loadingTab
                            ? "!tw-border-roll"
                            : "tw-border-neutral-25"
                        } tw-border-dashed tw-border-2 tw-rounded-md tw-mt-4`}
                      >
                        <img
                          className='tw-h-30 tw-w-40'
                          src={subirDocumentoNube}
                          alt='updateImg'
                        />
                        <div className='tw-flex tw-flex-col tw-w-fit tw-h-fit tw-items-start tw-ml-8'>
                          <p className='tw-w-full tw-pb-4 tw-text-start'>
                            <Trans
                              i18nKey='integracion.update.dndLabel'
                              components={[
                                <span
                                  className='tw-font-medium'
                                  key='0'
                                />,
                                <span
                                  className='tw-text-info-100 tw-cursor-pointer'
                                  key='1'
                                  onClick={open}
                                />,
                              ]}
                            />
                          </p>
                          <small className='tw-pb-6 tw-text-left'>
                            {t("tickets.dropzone.maxSheet")}
                          </small>
                          <Button
                            type='button'
                            className='!tw-w-44 [&>:nth-child(1)]:!tw-mx-2 !tw-bg-primary hover:!tw-bg-primary-over !tw-border-transparent !tw-px-4 tw-text-white tw-cursor-pointer tw-h-10 tw-rounded tw-flex tw-justify-center tw-items-center'
                            onClick={open}
                            loading={loadingTab}
                          >
                            {loadingTab
                              ? ` ${t("integracion.update.isSearchDocument")}`
                              : t("integracion.update.searchDocument")}
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                </section>
              )}
            </Dropzone>
          </div>
        </div>
      </div>
      <div className='tw-px-6 tw-bg-white tw-w-full tw-py-4 tw-justify-between tw-flex tw-flex-row tw-items-center tw-mt-6 tw-shadow-inner'>
        <div className='tw-w-fit tw-flex tw-flex-row'>
          {values.asientosContables.show && (
            <ButtonPrimeReact
              onClick={() =>
                !values.asientosContables.status &&
                setFieldValue("screen", MODES_INTEGRACIONES.ASIENTOS_CONTABLES)
              }
              className={`!tw-bg-transparent !tw-border-transparent ${
                !values.asientosContables.status
                  ? values.screen === MODES_INTEGRACIONES.ASIENTOS_CONTABLES
                    ? "hover:!tw-!tw-text-primary hover:!tw-border-transparent !tw-cursor-default !tw-text-primary"
                    : "hover:!tw-text-text-hyperlink hover:!tw-border-text-hyperlink tw-cursor-pointer !tw-text-primary"
                  : "!tw-cursor-default !tw-text-secondary"
              } tw-rounded tw-flex tw-flex-row tw-items-center tw-w-fit tw-h-fit tw-px-4 tw-py-2  tw-mx-2`}
            >
              {!values.asientosContables.status ? (
                <FontAwesomeIcon
                  icon={["fal", "clock"]}
                  className='tw-w-5 tw-h-5 tw-mr-2'
                />
              ) : (
                <FontAwesomeIcon
                  icon={["fal", "circle-check"]}
                  className='tw-w-5 tw-h-5 tw-mr-2'
                />
              )}
              <p className='tw-m-0'>
                {t("integracion.update.asientoContable")}
              </p>
            </ButtonPrimeReact>
          )}
          {values.contactos.show && (
            <ButtonPrimeReact
              onClick={() =>
                !values.contactos.status &&
                setFieldValue("screen", MODES_INTEGRACIONES.CONTACTOS)
              }
              className={`!tw-bg-transparent !tw-border-transparent ${
                !values.contactos.status
                  ? values.screen === MODES_INTEGRACIONES.CONTACTOS
                    ? "hover:!tw-!tw-text-primary hover:!tw-border-transparent !tw-cursor-default !tw-text-primary"
                    : "hover:!tw-text-text-hyperlink hover:!tw-border-text-hyperlink tw-cursor-pointer !tw-text-primary"
                  : "!tw-cursor-default !tw-text-secondary"
              } tw-rounded tw-flex tw-flex-row tw-items-center tw-w-fit tw-h-fit tw-px-4 tw-py-2 tw-mx-2`}
            >
              {!values.contactos.status ? (
                <FontAwesomeIcon
                  icon={["fal", "clock"]}
                  className='tw-w-5 tw-h-5 tw-mr-2'
                />
              ) : (
                <FontAwesomeIcon
                  icon={["fal", "circle-check"]}
                  className='tw-w-5 tw-h-5 tw-mr-2'
                />
              )}
              <p className='tw-m-0'>{t("integracion.update.contact")}</p>
            </ButtonPrimeReact>
          )}
          {values.libroIva.show && (
            <ButtonPrimeReact
              onClick={() =>
                !values.libroIva.status &&
                setFieldValue("screen", MODES_INTEGRACIONES.CONTACTOS)
              }
              className={`!tw-bg-transparent !tw-border-transparent ${
                !values.libroIva.status
                  ? values.screen === MODES_INTEGRACIONES.LIBRO_IVA
                    ? "hover:!tw-!tw-text-primary hover:!tw-border-transparent !tw-cursor-default !tw-text-primary"
                    : "hover:!tw-text-text-hyperlink hover:!tw-border-text-hyperlink tw-cursor-pointer !tw-text-primary"
                  : "!tw-cursor-default !tw-text-secondary"
              } tw-rounded tw-flex tw-flex-row tw-items-center tw-w-fit tw-h-fit tw-px-4 tw-py-2 tw-mx-2`}
            >
              {!values.libroIva.status ? (
                <FontAwesomeIcon
                  icon={["fal", "clock"]}
                  className='tw-w-5 tw-h-5 tw-mr-2'
                />
              ) : (
                <FontAwesomeIcon
                  icon={["fal", "circle-check"]}
                  className='tw-w-5 tw-h-5 tw-mr-2'
                />
              )}
              <p className='tw-m-0'>{t("integracion.update.libroIva")}</p>
            </ButtonPrimeReact>
          )}
        </div>
        <ButtonPrimeReact
          onClick={handleSubmit}
          loading={values.loadingSubmit}
          disabled={values.loadingSubmit}
          className='!tw-bg-primary hover:!tw-bg-primary-over !tw-border-none tw-cursor-pointer !tw-w-40'
        >
          {t("integracion.update.importData")}
        </ButtonPrimeReact>

        <Modal
          size='small'
          className='tw-rounded-md tw-p-10'
          maskClassName='!tw-z-20'
          headerClassName='!tw-p-0'
          header={
            <div className='tw-w-full !tw-h-40	 tw-flex tw-flex-row tw-justify-center !tw-p-0'>
              <img
                alt='integraciones'
                src={imgIntegraciones}
                className='!tw-w-40 !tw-h-40	'
              />
            </div>
          }
          visible={values.modals.success}
          closable={false}
        >
          <div className='tw-flex tw-flex-col tw-w-full tw-items-center'>
            <p className='tw-m-0 tw-w-full tw-text-wrap tw-text-center tw-font-medium tw-text-2xl tw-mb-2'>
              {t("integracion.update.isImportData")}
            </p>
            <p className='tw-m-0 tw-w-full tw-text-wrap tw-text-center tw-font-medium'>
              {t("integracion.update.msgSucessImport")}
            </p>
            <p className='tw-m-0 tw-w-full tw-text-wrap tw-text-start tw-mt-3'>
              {t("integracion.update.msgSucessText")}
            </p>
            <ButtonPrimeReact
              onClick={() => setFieldValue("modals.success", false)}
              className='tw-mt-10 tw-w-full tw-h-12 tw-rounded-md tw-bg-primary tw-text-white hover:tw-bg-primary-over tw-cursor-pointer tw-flex tw-justify-center tw-items-center'
            >
              {t("integracion.update.continuar")}
            </ButtonPrimeReact>
          </div>
        </Modal>
      </div>
    </div>
  )
}

const IntegrationUpdateForm = withFormik({
  validateOnChange: false,
  validateOnBlur: true,
  mapPropsToValues: ({ data }: $TSMigrationFixMe) => {
    return {
      screen: data.asientosContables
        ? MODES_INTEGRACIONES.ASIENTOS_CONTABLES
        : data.contactos
        ? MODES_INTEGRACIONES.CONTACTOS
        : MODES_INTEGRACIONES.LIBRO_IVA,
      modals: {
        charge: false,
        success: false,
        msgUpdate: null,
        chargePercent: 0,
      },
      loadingSubmit: false,
      type: data.type,
      ...(data.type === TYPES_INTEGRACIONES.SAGE && SAGE_INFO(data)),
    }
  },
  validationSchema: ({ t }: { t: $TSMigrationFixMe }) =>
    validationSchemaIntegraciones(t),
  handleSubmit: async (values, { ...props }) => {
    submitIntegration(
      values,
      props.setFieldValue,
      false,
      props.props.history,
      props.props.t,
      props.props.setShowLoadingModal
    )
  },
})(IntegrationUpdate)

const IntegrationPageUpdate = () => {
  const history = useHistory()
  const { state } = useLocation()
  const { t } = useTranslation()
  const [showLoadingModal, setShowLoadingModal] = useState(false)

  return (
    <div className='tw-w-full tw-h-full'>
      <IntegrationUpdateForm
        data={state}
        history={history}
        t={t}
        setShowLoadingModal={setShowLoadingModal}
      />
      <ModalLoading
        isOpen={showLoadingModal}
        title={t("integracion.update.modalLoadingTitle")}
      />
    </div>
  )
}

export default IntegrationPageUpdate
